import { graphql } from "gatsby";
import borderPatterns from "styles/theming/border-patterns.module.less";
import {
  SessionStorageHelper,
  UpcomingBlock as UpcomingBlockCore,
  multipleClassNames,
  SimplifyGatsbyQuery,
} from "@parksandresorts/core";

const UpcomingBlock = ({
  contentful_id,
  borderPattern,
  ...props
}: SimplifyGatsbyQuery<Queries.UpcomingBlockFragment>) => {
  return (
    <UpcomingBlockCore
      {...props}
      contentfulId={contentful_id}
      showContentfulIdToExclude={SessionStorageHelper.getItem("currentConcertPage")}
      extraClasses={borderPattern && multipleClassNames("block--with-border", borderPatterns[borderPattern])}
    />
  );
};

export default UpcomingBlock;

export const fragmentUpcomingBlock = graphql`
  fragment UpcomingBlock on ContentfulUpcomingBlock {
    contentful_id
    id
    today
    headline
    subheading
    upcomingItemLimit
    tag {
      title
    }
    showDuplicateEvents
    primaryButtonText
    primaryButtonLink {
      internalLink {
        slug
      }
      externalUrl
    }
    secondaryButtonText
    secondaryButtonLink {
      internalLink {
        slug
      }
      externalUrl
    }
    componentTheme
    borderPattern
  }
`;
